import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { useTranslation } from 'react-i18next'
import TextLink from 'components/Luxkit/TextLink'
import { setGridStyle } from './utils'

const TileContainer = styled.div`
  color: ${props => props.theme.palette.neutral.one};
  display: flex;
  gap: ${rem(12)};
  width: 70vw;

  ${mediaQueryUp.xs} {
    flex-direction: column;
    width: ${rem(296)};
  }

  ${mediaQueryUp.sm} {
    width: unset;
  }
`
const GridContainer = styled.div`
  ${setGridStyle}
`

export interface ValueSectionItem {
  key: string;
  headingI18Key: string;
  bodyI18Key: string;
  icon: JSX.Element;
  link?: ValueSectionItemLink;
}

interface ValueSectionItemLink {
    textI18Key: string;
    href?: string;
}

interface Props {
  values: ValueSectionItem[];
  i18Namespace: string;
}

const ValuePropositionItems = ({ values, i18Namespace }: Props) => {
  const { t } = useTranslation(i18Namespace)
  return (<GridContainer columns={values.length}>{values.map(({ icon, headingI18Key, bodyI18Key, link, key }) => {
    const linkText = link?.textI18Key ? t(link?.textI18Key, { ns: i18Namespace }) : undefined
    return (
      <TileContainer key={key}>
        {icon}
        <Group direction="vertical" gap={12}>
          <Group direction="vertical" gap={4}>
            <BodyText variant="medium" weight="bold">
              {t(headingI18Key, { ns: i18Namespace })}
            </BodyText>
            <BodyText variant="medium">
              {t(bodyI18Key, { ns: i18Namespace })}
            </BodyText>
          </Group>
          {link?.textI18Key && (
            <TextLink href={link?.href} size="small" weight="bold" target="_blank">
              {linkText}
            </TextLink>
          )}
        </Group>
      </TileContainer>
    ) })
  }</GridContainer>)
}
export default ValuePropositionItems
